export const FETCH_SITE_ACTIVITY_HISTORY_REQUEST = '@siteActivityHistory/FETCH_SITE_ACTIVITY_HISTORY_REQUEST';
export const FETCH_SITE_ACTIVITY_HISTORY_SUCCESS = '@siteActivityHistory/FETCH_SITE_ACTIVITY_HISTORY_SUCCESS';
export const FETCH_SITE_ACTIVITY_HISTORY_FAILED = '@siteActivityHistory/FETCH_SITE_ACTIVITY_HISTORY_FAILED';
export const CLEAR_SITE_ACTIVITY_HISTORY = '@siteActivityHistory/CLEAR_SITE_ACTIVITY_HISTORY';
